export const mutations = {
  setFeeTypeLevel1: function (state, fee_type_level1) {
    state.fee_type_level1 = fee_type_level1;
  },
  setFeeTypeLevel2: function (state, fee_type_level2) {
    state.fee_type_level2 = fee_type_level2;
  },
  setFeeTypeLevel3: function (state, fee_type_level3) {
    state.fee_type_level3 = fee_type_level3;
  },
  setFeeTypeLevel4: function (state, fee_type_level4) {
    state.fee_type_level4 = fee_type_level4;
  },
};
